export function getUserTokenFromLocalStorage() {
  const userString = window.localStorage.getItem('user');

  let userFromLS = userString !== null ? JSON.parse(userString) : null;
  if (userFromLS !== null && Date.now() > userFromLS.stsTokenManager.expirationTime) {
    // Login info is expired
    userFromLS = null;
    window.localStorage.removeItem('user');
  }

  return userFromLS;
}
